type ConfigNames =
   | 'product'
   | 'advisor'
   | 'documentTemplate'
   | 'businessPlan'
   | 'businessPlanning'
   | 'marketingPlan'
   | 'successionPlan'
   | 'client'
   | 'document'
   | 'documentType'
   | 'preWork'
   | 'process'
   | 'sessionRecord'
   | 'workItem'
   | 'deliveryNotes'
   | 'goal'
   | 'subGoal'
   | 'action'
   | 'feedback'
   | 'meetingAssistant'
   | 'mindset'
   | 'meetingMinutes'
   | 'actionItems'
   | 'coachReport'

type NamingType = {
   [key in ConfigNames]: {
      singular: string
      plural: string
   }
}

export const namingConfig = {
   product: {
      singular: 'The Gap',
      plural: 'The Gap',
   },
   advisor: {
      singular: 'Advisor',
      plural: 'Advisors',
   },
   documentTemplate: {
      singular: 'Document Template',
      plural: 'Document Templates',
   },
   businessPlan: {
      singular: 'Business Plan',
      plural: 'Business Plans',
   },
   businessPlanning: {
      singular: 'Business Planning',
      plural: 'Business Planning',
   },
   marketingPlan: {
      singular: 'Marketing Plan',
      plural: 'Marketing Plans',
   },
   successionPlan: {
      singular: 'Succession Plan',
      plural: 'Succession Plans',
   },
   client: {
      singular: 'Client',
      plural: 'Clients',
   },
   document: {
      singular: 'Document',
      plural: 'Documents',
   },
   documentType: {
      singular: 'Document Type',
      plural: 'Document Types',
   },
   preWork: {
      singular: 'Pre-work',
      plural: 'Pre-work',
   },
   feedback: {
      singular: 'Feedback',
      plural: 'Feedback',
   },
   process: {
      singular: 'Process',
      plural: 'Processes',
   },
   sessionRecord: {
      singular: 'Session Record',
      plural: 'Session Records',
   },
   workItem: {
      singular: 'Work Item',
      plural: 'Work Items',
   },
   deliveryNotes: {
      singular: 'Delivery Note',
      plural: 'Delivery Notes',
   },
   meetingAssistant: {
      singular: 'Scribe',
      plural: 'Scribe',
   },
   mindset: {
      singular: 'Mindset',
      plural: 'Mindsets',
   },
   meetingMinutes: {
      singular: 'Meeting Minutes',
      plural: 'Meeting Minutes',
   },
   actionItems: {
      singular: 'Action Items',
      plural: 'Action Items',
   },
   coachReport: {
      singular: 'Coaching Report',
      plural: 'Coaching Reports',
   },
   // Sentence case
   goal: {
      singular: 'goal',
      plural: 'goals',
   },
   // Sentence case
   subGoal: {
      singular: 'sub-goal',
      plural: 'sub-goals',
   },
   // Sentence case
   action: {
      singular: 'action',
      plural: 'actions',
   },
} as const satisfies NamingType

// same as namingConfig but in lowercase
export const namingConfigLowerCase = Object.fromEntries(
   Object.entries(namingConfig).map(([key, value]) => [
      key,
      Object.fromEntries(Object.entries(value).map(([subKey, subValue]) => [subKey, subValue.toLowerCase()])),
   ])
) as NamingType
